import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutZoneRegionLookup extends Layout {
    sourceZoneRegion: DataSource;
    tableZoneRegionLookup: Table;
}
